module.exports = __webpack_public_path__ + "img/logo.23f60c38.png";